<template>
  <div class="page-wrap p-3">
    <div class="page-header p-3 mb-3 mt-3">
      <h3>Обучающиеся военной кафедры</h3>
      <div class="add-item-block mt-3 mb-3 d-flex justify-content-end">
        <b-button variant="success"
                  v-if="isAdmin()"
                  @click="onClickImport()">
          Импортировать данные
        </b-button>
      </div>

      <div class="filters">
        <div class="row col-md-9">
          <div class="el-input-group">
            <label for="iin" class="form-label col-md-3"></label>
            <div class="col-md-9">
              <div class="input-group">
                <input class="form-control" type="text" placeholder="Поиск по ФИО/ИИН"
                       id="iin"
                       v-model="page.filter.search"
                       style="font-style: italic;">
                <button class="btn btn-primary" type="button" @click="reloadList()">
                  Найти
                </button>
              </div>
            </div>
          </div>
        </div>


          <div class="row col-md-9">
            <div class="el-input-group">
              <label for="trancheYear" class="form-label col-md-3">
                Год
              </label>
              <div class="col-md-9">
                <select v-model="page.filter.trancheYear" id="trancheYear"
                        v-on:change="reloadList()"
                        class="form-select">
                  <option v-for="(year, index) in trancheYears" :key="index" :value="year">
                    {{ year }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <div class="row col-md-9">
            <div class="el-input-group">
              <label for="trancheNumber" class="form-label col-md-3">
                Номер транша
              </label>
              <div class="col-md-9">
                <select v-model="page.filter.trancheNumber" id="trancheNumber"
                        v-on:change="reloadList()"
                        class="form-select">
                  <option v-for="(trancheNumber, index) in trancheNumbers" :key="index" :value="trancheNumber">
                    {{ trancheNumber }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <div class="row col-md-9" v-if="isAdmin() || isManagerFC()">
            <div class="el-input-group">
              <label for="university" class="form-label col-md-3">
                ВУЗ
              </label>
              <div class="col-md-9">
                <multiselect
                    v-model="page.filter.university"
                    :options="universities"
                    :searchable="true"
                    :closeOnSelect="true"
                    label="nameRu"
                    track-by="universityId"
                    :close-on-select="true"
                    :allow-empty="true"
                    placeholder="Выберите ВУЗ"
                    :multiple="false"
                    :clear-on-select="true"
                    @select="val => {
                      page.filter.universityId = val?.universityId || null;
                      reloadList();
                    }"
                />
              </div>
            </div>
          </div>


          <div class="row col-md-9">
            <div class="el-input-group">
              <label for="isLoadedFile" class="form-label col-md-3">
                Документ прикреплен
              </label>
              <div class="col-md-9">
                <select v-model="page.filter.isLoadedFile" id="isLoadedFile"
                        v-on:change="reloadList()"
                        class="form-select">
                  <option :value="null">Все</option>
                  <option v-for="item in yesNoList" :key="item.id"
                          :value="item.id">
                    {{ item.nameRu }}
                  </option>
                </select>
              </div>
            </div>
          </div>


        <div class="row col-md-9">
          <div class="el-input-group">
            <label for="isFirstCourse" class="form-label col-md-3">
              1 курс (новый прием)
            </label>
            <div class="col-md-9">
              <select v-model="page.filter.isFirstCourse" id="isFirstCourse"
                      v-on:change="reloadList()"
                      class="form-select">
                <option :value="null">Все</option>
                <option v-for="option in yesNoList" :key="option.id"
                        :value="option.id">
                  {{ option.nameRu }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="page-content mt-3 mb-3">
    <div class="page-content-info d-flex align-items-center justify-content-end">
      <b-button variant="success"
                v-if="isManagerFC() || isUniversityManager()"
                :disabled="items.length === 0"
                @click="onClickExportStudents()">
        Экспортировать в MS Excel
      </b-button>

      <b-button variant="danger"
                :disabled="selectedItemIds.length === 0"
                v-if="isAdmin()"
                @click="onClickSelectedRemove()">
        Удалить выбранные
      </b-button>

      <b-button variant="danger"
                style="margin-left: 5px"
                :disabled="items.length === 0"
                v-if="isAdmin()"
                @click="onClickAllRemove()">
        Удалить все
      </b-button>
    </div>

    <div class="page-content-info d-flex align-items-center justify-content-between">
      <div>Найдено: <span>{{ totalCount }}</span></div>
    </div>

    <b-table striped hover
             :items="items"
             :fields="fields"
             responsive="sm"
             no-local-sorting
             show-sort-labels>
      <template #head(iin)="data">
        <div class="sortable-container none"
             @click="onSortChanged('iin')"
             :class="{'ascending': page.sort.iin === 'ASC', 'descending': page.sort.iin === 'DESC'}">
          ИИН
        </div>
      </template>
      <template #head(lastname)="data">
        <div class="sortable-container none"
             @click="onSortChanged('lastname')"
             :class="{'ascending': page.sort.lastname === 'ASC', 'descending': page.sort.lastname === 'DESC'}">
          Фамилия
        </div>
      </template>
      <template #head(firstname)="data">
        <div class="sortable-container none"
             @click="onSortChanged('firstname')"
             :class="{'ascending': page.sort.firstname === 'ASC', 'descending': page.sort.firstname === 'DESC'}">
          Имя
        </div>
      </template>
      <template #head(patronymic)="data">
        <div class="sortable-container none"
             @click="onSortChanged('patronymic')"
             :class="{'ascending': page.sort.patronymic === 'ASC', 'descending': page.sort.patronymic === 'DESC'}">
          Отчество
        </div>
      </template>
      <template #head(universityName)="data">
          ВУЗ
      </template>
      <template #head(actions)="data" v-if="canRemove()">
      </template>

      <template #cell(index)="data">
        <div class="form-check2">
          <input class="form-check-input" type="checkbox"
                 v-on:change="onCheckItem(data.item)"
                 v-model="data.item.selected"/>
        </div>

      </template>

      <template #cell(iin)="data">
        {{ data.item.iin }}
      </template>
      <template #cell(lastname)="data">
        <a :href="`/military-students/${data.item.uuid}`">
          {{ data.item.lastname }}
        </a>
      </template>
      <template #cell(firstname)="data">
        <a :href="`/military-students/${data.item.uuid}`">
          {{ data.item.firstname }}
        </a>
      </template>
      <template #cell(patronymic)="data">
        <a :href="`/military-students/${data.item.uuid}`">
          {{ data.item.patronymic }}
        </a>
      </template>

      <template #cell(universityName)="data">
        <a :href="`/military-students/${data.item.uuid}`">
          {{ data.item.universityName }}
        </a>
      </template>
      <template #cell(actions)="data" v-if="canRemove()">
        <div class="action-cell">
          <b-button class="btn btn-danger btn-sm delete-button"
                    @click="onClickRemove(data.item)">
            Удалить
          </b-button>
        </div>
      </template>
    </b-table>
  </div>
  <div class="page-footer">
    <b-pagination
        v-model="page.partNumber"
        :total-rows="totalCount"
        :per-page="page.countInPage"
        v-on:click="reloadList"
        first-text="<<"
        last-text=">>"
        class="mt-3"
    ></b-pagination>
  </div>

  <!-- Modal component -->
  <b-modal v-model="showModal" title="Импорт обучающихся" @ok="submitForm">
    <form @submit.prevent="submitForm" class="mb-4">
      <div class="mb-3">
        <label for="trancheYear" class="form-label">
          Год
        </label>
        <select v-model="dialog.filter.trancheYear" id="trancheYear" required
                class="form-select">
          <option v-for="(year, index) in trancheYears" :key="index" :value="year">
            {{ year }}
          </option>
        </select>
      </div>

      <div class="mb-3">
        <label for="trancheNumber" class="form-label">
          Номер транша
        </label>
        <select v-model="dialog.filter.trancheNumber" id="trancheNumber"
                class="form-select" required>
          <option v-for="(trancheNumber, index) in trancheNumbers" :key="index" :value="trancheNumber">
            {{ trancheNumber }}
          </option>
        </select>
      </div>

      <div class="mb-3">
        <label for="fileUpload" class="form-label">
          Файл с данными (*.csv)
          <span class="text-danger">*</span>
        </label>
        <div class="col-md-9">
          <input type="file" id="fileUpload" @change="handleFileUpload" accept=".csv" class="form-control"/>
        </div>
      </div>
    </form>
  </b-modal>

  <vue-loading :active.sync="isLoading" :is-full-page="true"></vue-loading>
</template>

<script>

import VueLoading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import militaryStudentService from "@/services/militaryStudentService";
import {showErrorNotify, showSuccessNotify} from "@/utils/notificationUtils";
import universityService from "@/services/universityService";
import settingsService from "@/services/settingsService";
import delegationService from "@/services/delegationService";
import xlsExportService from "@/services/xlsExportService";
import {TemplateTypeEnum} from "@/enum/TemplateTypeEnum";
import {saveAs} from "@/assets/FileSaver.min";
import Multiselect from "vue-multiselect";

export default {
  components: {
    VueLoading,
    Multiselect,
  },
  data() {
    return {
      isLoading: false,
      showModal: false,
      uploadedFile: null,
      setting: {
        defaultTrancheYear: null,
        defaultTrancheNumber: null
      },
      page: {
        filter: {
          search: null,
          trancheYear: null,
          trancheNumber: null,
          universityId: null,
          isLoadedFile: null,
          isFirstCourse: null
        },
        sort: {
          studentId: null,
          firstname: null,
          lastname: null,
          patronymic: null
        },
        partNumber: 1,
        countInPage: 10,
      },
      totalCount: 0,
      fields: [
        {key: 'index', label: '#', sortable: false, thStyle: { width: "40px" }},
        {key: 'iin', label: 'ИИН', sortable: true},
        {key: 'lastname', label: 'Фамилия', sortable: true},
        {key: 'firstname', label: 'Имя', sortable: true},
        {key: 'patronymic', label: 'Отчество', sortable: true},
        {key: 'universityName', label: 'ВУЗ', sortable: false},
        {key: 'actions', label: '', sortable: false}
      ],
      items: [],
      selectedItemIds: [],
      universities: [],
      yesNoList: [
        {id: true, nameRu: "Да"},
        {id: false, nameRu: "Нет"},
      ],
      dialog: {
        filter: {
          trancheYear: null,
          trancheNumber: null
        }
      },
      trancheYears: Array.from({length: 7}, (v, i) => 2024 + i),
      trancheNumbers: Array.from({length: 4}, (v, i) => 1 + i)
    };
  },
  methods: {
    init() {
      this.initSettings().then(response => {
        this.page.filter.trancheYear = this.setting.defaultTrancheYear;
        this.page.filter.trancheNumber = this.setting.defaultTrancheNumber;

        this.reloadList();
      });
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (file) {
        this.uploadedFile = file;
      } else {
        showErrorNotify("Выберите файл для загрузки");
      }
    },
    async reloadList() {
      this.selectedItemIds = [];
      this.isLoading = true;
      const response = await militaryStudentService.getAll(this.page);
      this.items = response.list;
      this.totalCount = response.count;
      this.isLoading = false;
    },
    onSortChanged(column) {
      this.page.sort = {
        ...this.page.sort,
        [column]: this.page.sort[column] === 'ASC' ? 'DESC' : 'ASC'
      };
      this.reloadList();
    },
    async submitForm() {
      if (!this.uploadedFile) {
        showErrorNotify("Убедитесь, что все обязательные поля заполнены");
        return;
      }

      this.isLoading = true;

      try {
        const formData = new FormData();
        formData.append('file', this.uploadedFile);
        formData.append('trancheYear', this.dialog.filter.trancheYear);
        formData.append('trancheNumber', this.dialog.filter.trancheNumber);

        await militaryStudentService.uploadStudentsCsv(formData);

        this.reloadList();

        showSuccessNotify("Файл успешно загружен");
        this.showModal = false;
      } catch (error) {
        showErrorNotify("Ошибка при загрузке файла");
      } finally {
        this.isLoading = false;
      }
    },
    async onClickRemove(item) {
      const confirmed = await confirm("Вы уверены, что хотите удалить этот элемент?");
      if (confirmed) {
        try {
          await militaryStudentService.deleteById(item.uuid);

          this.reloadList();

          showSuccessNotify('Успешно удалено');
        } catch (exc) {
          showErrorNotify('Возникла ошибка при удалении');
        }
      }
    },
    onClickImport() {
      this.uploadedFile = null;

      this.dialog.filter.trancheYear = this.setting.defaultTrancheYear;
      this.dialog.filter.trancheNumber = this.setting.defaultTrancheNumber;

      this.showModal = true;
    },
    async initSettings() {
      this.setting = await settingsService.load();
    },
    initUniversities() {
      const params = {
        partNumber: 1,
        countInPage: 0,
        filter: {}
      };
      universityService.getAll(params)
          .then(response => {
            this.universities = response.list.sort((a, b) => a.nameRu.localeCompare(b.nameRu));
          });
    },
    async onClickExportStudents() {
      this.isLoading = true;
      const response = await xlsExportService.exportMilitaryStudents(TemplateTypeEnum.MILITARY_STUDENTS_XLSX, this.page);
      const blob = new Blob([response], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
      saveAs(blob, "document.xlsx");
      this.isLoading = false;
    },
    canRemove() {
      return this.isAdmin();
    },
    isAdmin() {
      return delegationService.isAdmin();
    },
    isManagerFC() {
      return delegationService.isManagerFC();
    },
    isUniversityManager() {
      return delegationService.isUniversityManager();
    },
    onCheckItem(item) {
      if (item.selected) {
        this.selectedItemIds.push(item.uuid);
      } else {
        const index = this.selectedItemIds.findIndex(uuid => uuid === item.uuid);
        if (index !== -1) {
          this.selectedItemIds.splice(index, 1);
        }
      }
    },
    async onClickSelectedRemove() {
      console.log('onClickSelectedRemove', this.selectedItemIds);

      const confirmed = await confirm("Вы уверены, что хотите удалить выбранные элементы?");
      if (confirmed) {
        try {
          await militaryStudentService.deleteByIds(this.selectedItemIds);

          this.reloadList();

          showSuccessNotify('Успешно удалено');
        } catch (exc) {
          showErrorNotify('Возникла ошибка при удалении');
        }
      }
    },

    async onClickAllRemove() {

      const confirmed = await confirm("Вы уверены, что хотите удалить все элементы?");
      if (confirmed) {
        try {
          this.isLoading = true;
          await militaryStudentService.deleteAllByYear(this.page.filter.trancheYear, this.page.filter.trancheNumber, this.page.filter.universityId);
          this.isLoading = false;

          this.reloadList();

          showSuccessNotify('Все успешно удалено');
        } catch (exc) {
          showErrorNotify('Возникла ошибка при удалении');
        }
      }
    }
  },
  mounted() {
    this.initUniversities();

    this.init();
  }
};
</script>

<style scoped>
.row {
  padding-top: 5px;
}

.ascending {
  background-image: url("../assets/asc.svg") !important;
}

.descending {
  background-image: url("../assets/desc.svg") !important;
}

.none {
  background-image: url("../assets/none.svg");
  margin-left: 10px !important;
}

.sortable-container {
  background-position: right calc(0.75rem / 2) center;
  background-repeat: no-repeat;
  background-size: 0.65em 1em;
  vertical-align: middle !important;
  margin-right: 10px !important;
  padding-right: 15px !important;
  cursor: pointer;
}

th div {
  width: 100% !important;
  display: grid !important;
}

.p-3 {
  padding: 0 !important;
}

.action-cell {
  display: flex;
  justify-content: flex-end;
}

.delete-button {
  display: flex;
  align-items: center;
}

</style>
